export default {
  name: 'PreviewFiles',

  methods: {
    showImages (event, removeApiConfig = {}, tabKey = '') {
      const { data: images } = event || {}
      if (images?.length) {
        const imagesSrcs = images.map(image => {
          return {
            ...image,
            tabKey,
            data: image?.original_url || image || null
          }
        })

        this.$set(this.imagesPreviewDialogConfig, 'images', imagesSrcs)
        this.$set(this.imagesPreviewDialogConfig, 'removeApiConfig', removeApiConfig)
        this.$set(this.imagesPreviewDialogConfig, 'show', true)
      }
    },

    showPdfs (event, removeApiConfig = {}, tabKey = '') {
      const { data: pdfs } = event || {}
      if (pdfs?.length) {
        const files = pdfs.map(pdf => {
          return {
            ...pdf,
            tabKey
          }
        })

        this.$set(this.filesPreviewDialogConfig, 'files', files)
        this.$set(this.filesPreviewDialogConfig, 'removeApiConfig', removeApiConfig)
        this.$set(this.filesPreviewDialogConfig, 'show', true)
      }
    }
  }
}
